import { Badge } from '@/components/ui/badge';
import { ReferralStage } from '@/types';

export const REFERRAL_STAGE_LABELS: Record<ReferralStage, string> = {
  lead: 'New lead',
  lost: 'Did not sign up',
  signed_up: 'Signed up',
  trial: 'Free trial',
  paying: 'Paying',
  closed: 'Closed',
};

const VARIANTS: Record<ReferralStage, 'submitted' | 'rejected' | 'approved' | 'trial' | 'active' | 'cancelled'> = {
  lead: 'submitted',
  lost: 'rejected',
  signed_up: 'approved',
  trial: 'trial',
  paying: 'active',
  closed: 'cancelled',
};

export function ReferralStageBadge({ stage, label }: { stage: ReferralStage; label?: string }) {
  return <Badge variant={VARIANTS[stage] || 'default'}>{label || REFERRAL_STAGE_LABELS[stage] || stage}</Badge>;
}
